import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";

import LoginService from "../../services/loginService";
import UserService from "../../services/userService";
import NotificationService from "../Notification/notificationService";

import { Collection } from "../../types/authTypes";
import { RootState } from "../../state";
import { Actions, Subjects } from "../../permission/constants";
import { Collection as CollectionEntity } from "../../entities/Collection";

import CustomSwitch from "../CustomSwitch/CustomSwitch";
import SortButtonForProfile, {
  SortElement,
} from "../Buttons/SortButton/SortButtonForProfile";
import { AbilityContext } from "../../permission/Can";

interface CollectionOptionsBarProps {
  isOwnProfile: boolean;
  setOrderBy: Function;
  targetUser: number | undefined;
}

const CollectionOptionsBar = ({
  isOwnProfile,
  setOrderBy,
  targetUser,
}: CollectionOptionsBarProps) => {
  const loginData = useSelector((state: RootState) => state.login);

  const [collectionInstance, setCollectionInstance] =
    useState<CollectionEntity>(
      new CollectionEntity(targetUser ? targetUser : 0)
    );
  const [isPrivate, setIsPrivate] = useState<boolean>(
    loginData.collection?.private ? loginData.collection.private : false
  );
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);

  const { updateCollectionPrivacy } = UserService();
  const { saveUser } = LoginService();
  const { error, success } = NotificationService();
  const ability = useContext(AbilityContext);

  const sort = (value: SortElement) => {
    setOrderBy(value);
  };

  useEffect(() => {
    if (loginData.collection && isPrivate !== loginData.collection?.private) {
      if (ability.can(Actions.UPDATE_VISIBILITY, Subjects.COLLECTION)) {
        updateCollectionPrivacy(isPrivate).then((result) => {
          if (result) {
            success("Collection privacy updated");
            if (loginData.collection) {
              const collection: Collection = {
                id: loginData.collection.id,
                private: isPrivate,
              };
              saveUser({ ...loginData, collection: collection });
            }
          }
        });
      } else {
        window.location.href = "/upgrade-membership";
      }
    }
  }, [isPrivate]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1rem",
      }}
    >
      {isOwnProfile && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Box
            aria-label="PrivateCollectionTitle-Box"
            sx={{
              marginRight: "10px",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: { xs: "14px", sm: "1rem" },
              }}
            >
              Make collection private
            </Typography>
          </Box>
          <Box aria-label="PremiumWrapperButton-Box">
            {/* <PremiumWrapperButton
              action={Actions.UPDATE_VISIBILITY}
              entity={Subjects.SHIRT}
              text="Upgrade"
              component={
                <CustomSwitch
                  checked={isPrivate}
                  onChange={(e) => setIsPrivate(e.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              size="150px"
            /> */}

            <CustomSwitch
              checked={isPrivate}
              onChange={(e) => setIsPrivate(e.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Box>
        </Box>
      )}
      <Box sx={{ marginLeft: "auto", display: "inline-flex" }}>
        <SortButtonForProfile
          handleClick={sort}
          targetEntity={collectionInstance}
        />
      </Box>
    </Box>
  );
};

export default CollectionOptionsBar;
